import { extractData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import { TrailsDtoSchema, TrailsPageDtoSchema } from "./schemas";
import type { TrailsListType, TrailsPageType } from "./types";

export function mapDtoToTrailsPage(dto: unknown): TrailsPageType {
  const parsed = safeParseWithFallback(
    TrailsPageDtoSchema,
    dto,
    "mapDtoToTrailsPage",
  );

  return extractData(parsed, dto, dto as TrailsPageType);
}

export function mapDtoToTrails(dto: unknown): TrailsListType {
  const parsed = safeParseWithFallback(TrailsDtoSchema, dto, "mapDtoToTrails");
  const trails = extractData(parsed, dto, []) as TrailsListType;

  const getStatusPriority = (status: string | undefined) => {
    if (status === "open") return 0;
    if (status === "close") return 1;
    return 2;
  };

  return [...trails].sort((a, b) => {
    const aPriority = getStatusPriority(a.trailStatus);
    const bPriority = getStatusPriority(b.trailStatus);

    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    return (a.order ?? 0) - (b.order ?? 0);
  });
}
